<template>
  <div class="home">
    <!-- 导航按钮 -->
    <Navbar
      @scrollToSection="scrollToSection"
      :refNameList="refNameList"
      :navbarNameList="navbarNameList"
      :refNameIndex.sync="refNameIndex"
    />
    <div class="Placeholders"></div>

    <!-- 内容区域 -->
    <div class="content">
      <section ref="sectionBanner">
        <Banner />
      </section>
      <section ref="sectionProducts">
        <Products />
      </section>
      <section ref="sectionInvestment">
        <Investment />
      </section>
      <!-- <section ref="sectionNews">
        <News />
      </section> -->
      <section ref="sectionCompany">
        <Company />
      </section>
      <section ref="sectionBottom">
        <Bottom />
      </section>
      <!-- <section ref="section3" v-for="i in 10">
        <h2>第三部分</h2>
        <p>这是第三部分的内容。</p>
      </section> -->
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Banner from "./components/Banner.vue";
import Products from "./components/Products.vue";
import Investment from "./components/Investment.vue";
import News from "./components/News.vue";
import Company from "./components/Company.vue";
import Bottom from "./components/Bottom.vue"

import throttle from "@/utils/throttle.js";

export default {
  name: "home",
  components: {
    Navbar,
    Banner,
    Products,
    Investment,
    News,
    Company,
    Bottom,
  },
  data() {
    return {
      name: "首页",
      refNameList: [
        "sectionBanner",
        "sectionProducts",
        "sectionInvestment",
        // "sectionNews",
        "sectionCompany",
      ],
      // navbarNameList: ["首页", "产品介绍", "招商加盟", "新闻咨讯", "了解我们"],
      navbarNameList: ["首页", "产品介绍", "招商加盟", "了解我们"],
      refNameIndex: 0, // 当前可见的 refNameList 的索引
      visibilityStates: [], // 可见状态存储
      refOrderList: [], // 存储 ref 的顺序
    };
  },
  mounted() {
    console.log("MyComponent mounted"); // 输出：MyComponent mounted
    // this.refs = [this.$refs.section1, this.$refs.section2, this.$refs.section3];
    this.initVisibilityCheck(this.refNameList);
  },
  watch: {
    visibilityStates: {
      handler(newVal, oldVal) {
        console.log("可见性变化:", newVal);
        for (let index = 0; index < newVal.length; index++) {
          const visible = newVal[index];
          if (visible) {
            console.log("index:", index);
            this.refNameIndex = index;
            break;
          }
        }
      },
      deep: true,
    },
  },
  beforeDestroy() {
    this.removeScrollListener();
  },
  methods: {
    scrollToSection(selectorRefName) {
      this.$scrollIntoView("ref", this.$refs[selectorRefName], {
        behavior: "smooth", // 平滑滚动
        block: "start", // 垂直方向对齐到顶部
        offset: "1.1067rem",
      });
    },

    // 初始化可见性检测，detectionConfig-检测区域偏移配置
    initVisibilityCheck(refNames, detectionConfig = {}) {
      // 合并默认配置与传入参数
      this.detectionOffset = {
        top: 70,
        right: 0,
        bottom: 0,
        left: 0,
        ...detectionConfig,
      };

      this.$nextTick(() => {
        this.refOrderList = [...refNames];
        this.visibilityStates = new Array(refNames.length).fill(false);
        this.setupScrollListener();
        this.checkVisibility();
      });
    },

    // 设置滚动监听
    setupScrollListener() {
      this.validateDetectionConfig();

      this.scrollHandler = throttle(this.checkVisibility, 100);
      window.addEventListener("scroll", this.scrollHandler, { passive: true });
      window.addEventListener("resize", this.scrollHandler);
    },

    // 移除监听方法
    removeScrollListener() {
      if (this.scrollHandler) {
        window.removeEventListener("scroll", this.scrollHandler);
        window.removeEventListener("resize", this.scrollHandler);
        this.scrollHandler = null;
      }
    },

    // 增强版可见性检测（集成配置参数）
    checkVisibility() {
      this.refOrderList.forEach((refName, index) => {
        const elements = this.$refs[refName];
        if (!elements) return;

        const elementList = Array.isArray(elements) ? elements : [elements];
        const isVisible = elementList.some((el) =>
          this.isElementVisible(el, this.detectionOffset)
        );

        this.$set(this.visibilityStates, index, isVisible);
      });
    },

    // 可见性判断（接收动态配置）
    isElementVisible(el, offset) {
      // const targetEl = el.$el || el;
      // if (!targetEl?.getBoundingClientRect) return false;

      if (!el) return false;
      const targetEl = el.$el || el;
      if (!targetEl.getBoundingClientRect) return false;

      const rect = targetEl.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;

      // 应用动态偏移配置
      const visibleArea = {
        top: offset.top,
        bottom: windowHeight - offset.bottom,
        left: offset.left,
        right: windowWidth - offset.right,
      };

      const visibleHeight =
        Math.min(rect.bottom, visibleArea.bottom) -
        Math.max(rect.top, visibleArea.top);
      const visibleWidth =
        Math.min(rect.right, visibleArea.right) -
        Math.max(rect.left, visibleArea.left);
      const areaRatio =
        (visibleHeight * visibleWidth) / (rect.width * rect.height);

      return areaRatio > 0.1;
    },

    // 新增配置校验
    validateDetectionConfig() {
      const isValid = Object.values(this.detectionOffset).every((v) => v >= 0);
      if (!isValid) {
        console.error("检测区域偏移量必须为非负数");
        this.detectionOffset = { top: 0, right: 0, bottom: 0, left: 0 };
      }
    },
  },
};
</script>

<style scoped>
.home {
  overflow: hidden;
}

.Placeholders {
  height: 1.1067rem;
}

.content {
  height: auto;
  overflow-y: auto;
  border: 0.0158rem solid #ccc;
  /* padding: .3162rem; */
}

section {
  /* margin-bottom: 0.3162rem; */
}
</style>



// WEBPACK FOOTER //
// src/pages/home/home.vue